(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .service('swifPatrimoineService', swifPatrimoineService);

    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineService
        * @requires swif.framework.swifCadastreService
        * @requires swif.framework.swifPatrimoineContractService
        * @requires swif.framework.swifPatrimoineContractTypeService
        * @requires swif.framework.swifPatrimoineControlTypeService
        * @requires swif.framework.swifPatrimoinePurchaseModeService
        * @requires swif.framework.swifPatrimoineEquipmentService
        * @requires swif.framework.swifPatrimoineReferentielService
        * @description
        ```
        swifPatrimoineService.cadastre;
        swifPatrimoineService.contract;
        swifPatrimoineService.contract_type;
        swifPatrimoineService.control_type;
        swifPatrimoineService.purchase_mode;
        swifPatrimoineService.equipment;
        swifPatrimoineService.property;
        swifPatrimoineService.referentiel;
        ```
    **/
    function swifPatrimoineService(
        swifCadastreService,
        swifPatrimoineContractService, //biggest
        swifPatrimoineContractTypeService,
        swifPatrimoineControlTypeService,
        swifPatrimoinePurchaseModeService,
        swifPatrimoineEquipmentService,
        patrimoinePropertyService,
        swifPatrimoineReferentielService
    ) {
        var service = {
            cadastre: swifCadastreService,
            contract: swifPatrimoineContractService,
            contract_type: swifPatrimoineContractTypeService,
            control_type: swifPatrimoineControlTypeService,
            purchase_mode: swifPatrimoinePurchaseModeService,
            equipment: swifPatrimoineEquipmentService,
            property: patrimoinePropertyService,
            referentiel: swifPatrimoineReferentielService
        };
        return service;
    }
})();
